import React, { FC, useEffect, useState } from "react";
import ExpandMoreIcon from "../assets/svg/expand-more-icon.svg";
import CollapseIcon from "../assets/svg/collapse-icon.svg";
import svgIcons from "../assets/svg/svgIcons";

type AccordianProps = {
  title: string | React.ReactNode;
  children: React.ReactNode;
  openByDefault?: boolean;
  collapsible?: boolean;
  hasDetailsPage?: boolean;
  isMultiClick?: boolean;
  handleClass?: string;
  contentClass?: string;
  wrapperBorderClass?: string;
  highlightOnHover?: boolean;
  keepMounted?: boolean;
} & Omit<React.HTMLAttributes<HTMLDivElement>, "title">;

const Accordian: FC<AccordianProps> = ({
  title,
  children,
  openByDefault = false,
  collapsible = true,
  hasDetailsPage = true,
  isMultiClick = false,
  handleClass = "",
  contentClass = "",
  wrapperBorderClass = "border-b border-gray-200",
  highlightOnHover = false,
  keepMounted = false,
  ...moreHTMLDivElementProps
}) => {
  const [isOpen, setIsOpen] = useState(openByDefault);

  return (
    <div
      className={`${hasDetailsPage ? `${wrapperBorderClass} last-of-type:border-b-0` : ""}`}
      {...moreHTMLDivElementProps}
    >
      {typeof title === "string" ? (
        <button
          type="button"
          className={`w-full ${hasDetailsPage ? "px-5" : ""} py-[10px] flex items-center${collapsible ? " cursor-pointer" : ""}${highlightOnHover ? ` enabled:hover:bg-accent-blue-paleO66${isOpen ? " bg-accent-blue-paleO66" : ""}` : ""} ${handleClass}`}
          {...(collapsible && !isMultiClick
            ? {
                onClick: () => {
                  setIsOpen(!isOpen);
                },
              }
            : {})}
        >
          <div className="flex-grow text-left text-lg font-semibold leading-10 tracking-tighter text-accent-blue-dark">
            {title}
          </div>
          {collapsible && (
            <img
              src={isOpen ? svgIcons.CollapseIcon : svgIcons.ExpandMoreIcon}
              alt="expand-more-icon"
              onClick={() => (isMultiClick ? setIsOpen(!isOpen) : {})}
            />
          )}
        </button>
      ) : (
        <div
          className={`w-full ${hasDetailsPage ? "px-5" : ""} py-[10px] flex items-center${collapsible ? " Xcursor-pointer" : ""}${highlightOnHover ? ` hover:bg-accent-blue-paleO66${isOpen ? " bg-accent-blue-paleO66" : ""}` : ""} ${handleClass}`}
          {...(collapsible && !isMultiClick
            ? { onClick: () => setIsOpen(!isOpen) }
            : {})}
        >
          <div className="flex-grow text-left text-lg font-semibold leading-10 tracking-tighter text-accent-blue-dark">
            {title}
          </div>
          {collapsible && (
            <button
              type="button"
              onClick={() => (isMultiClick ? setIsOpen(!isOpen) : {})}
            >
              <img
                src={isOpen ? svgIcons.CollapseIcon : svgIcons.ExpandMoreIcon}
                alt="expand-more-icon"
              />
            </button>
          )}
        </div>
      )}
      {(isOpen || keepMounted) && 
      <div className={`${contentClass ?? ""} ${isOpen ? "" : "hidden"}`}>
        {children}
      </div>}
    </div>
  );
};

export default Accordian;
